export default "__VITE_ASSET__D_6i9Lmh__"